<div class="login-container">
    <div class="d-flex justify-content-center">
        <div class="link-device-div col-xl-6 col-lg-6 col-md-12 col-sm-12 row">
            <div class="information col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex flex-column justify-content-center">
                <div class="link-device-icon"></div>
                <h4 class='link-device-location'>Link device location</h4>
                <h6 class="create-unique">Create a unique identity for this device by entering location information</h6>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <form [formGroup]="addDeviceForm" (submit)="linkDevice()">
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <label class="form-label">Device Type</label>
                            <select class="form-control" formControlName="deviceType"
                                (ngModelChange)="buildDeviceRooms()" data-cy-select="deviceType"
                                [ngClass]="{ 'is-invalid': controls?.deviceType?.errors && controls.deviceType.touched }">
                                <option [ngValue]="null">Select device type</option>
                                <option [ngValue]="deviceType.key" *ngFor="let deviceType of deviceTypes">
                                    {{ deviceType.value }}
                                </option>
                            </select>
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && (controls.deviceType.touched || controls.deviceType.dirty)"
                                data-cy-validation="hospital">
                                <div *ngIf="controls.deviceType.hasError('required')">Device Type is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <label class="form-label">Hospital</label>
                            <select class="form-control" (ngModelChange)="onInstitutionChanged()"
                                formControlName="institution"
                                [ngClass]="{ 'is-invalid': controls?.institution?.errors && controls.institution.touched }"
                                data-cy-select="hospital">
                                <option [ngValue]="null">Select hospital</option>
                                <option [ngValue]="institution" *ngFor="let institution of institutions">
                                    {{ institution.name }}
                                </option>
                            </select>
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && (controls.institution.touched || controls.institution.dirty)"
                                data-cy-validation="hospital">
                                <div *ngIf="controls.institution.hasError('required')">Hospital is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <label class="form-label">Stock location</label>
                            <select class="form-control" formControlName="stockLocation"
                                [ngClass]="{ 'is-invalid': controls?.stockLocation?.errors && controls.stockLocation.touched }"
                                data-cy-select="stocklocation" (ngModelChange)="filter()">
                                <option [ngValue]="null">Select stock location</option>
                                <option [ngValue]="stockLocation" *ngFor="let stockLocation of stockLocations">
                                    {{ stockLocation.name }}
                                </option>
                            </select>
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && (controls.stockLocation.touched || controls.stockLocation.dirty)"
                                data-cy-validation="stocklocation">
                                <div *ngIf="controls.stockLocation.hasError('required')">Stock Location is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <label class="form-label">Physical location</label>
                            <select class="form-control" formControlName="physicalLocation"
                                (ngModelChange)="buildDeviceRooms()"
                                [ngClass]="{ 'is-invalid': controls?.physicalLocation?.errors && controls.physicalLocation.touched }"
                                data-cy-select="physicallocation" (ngModelChange)="filter()">
                                <option [ngValue]="null">Select physical location</option>
                                <option [ngValue]="physicalLocation" *ngFor="let physicalLocation of physicalLocations">
                                    {{ physicalLocation.name }}
                                </option>
                            </select>
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && (controls.physicalLocation.touched || controls.physicalLocation.dirty)"
                                data-cy-validation="physicallocation">
                                <div *ngIf="controls.physicalLocation.hasError('required')">Physical Location is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4" *ngIf="theatreRooms && theatreRooms.length > 0">
                        <div class="col-12">
                            <label class="form-label">Physical location Room</label>
                            <select class="form-control" formControlName="physicalLocationTheatreRoom"
                                [ngClass]="{ 'is-invalid': controls.physicalLocationTheatreRoom.errors && controls.physicalLocationTheatreRoom.touched }"
                                data-cy-select="physicalLocationTheatreRoom">
                                <option [ngValue]="null">Select physical location room</option>
                                <option [ngValue]="theatreRoom.id" *ngFor="let theatreRoom of theatreRooms">
                                    {{ theatreRoom.name }}
                                </option>
                            </select>
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && (controls.physicalLocationTheatreRoom.touched || controls.physicalLocationTheatreRoom.dirty)"
                                data-cy-validation="physicalLocationTheatreRoom">
                                <div *ngIf="controls.physicalLocationTheatreRoom.hasError('required')">Physical Location room is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <label class="form-label">Device name</label>
                            <input [required]="!this.enableLinkExistingDevice" type="text" formControlName="name" class="form-control"
                                placeholder="Start typing here" data-cy-input="name"
                                [ngClass]="{ 'is-invalid': !this.enableLinkExistingDevice && controls.name.errors && controls.name.touched }" />
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && !this.enableLinkExistingDevice && (controls.name.touched || controls.name.dirty)"
                                data-cy-validation="name">
                                <div *ngIf="controls.name.hasError('required')">Device Name is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4" *ngIf="enableLinkExistingDevice && filteredDevices && filteredDevices.length > 0">
                        <div class="col-12">
                            <label class="form-label">Or Link Existing Device</label>
                            <select class="form-control" formControlName="filteredDevice"
                                [ngClass]="{ 'is-invalid': controls.filteredDevice.errors && controls.filteredDevice.touched }"
                                data-cy-select="filteredDevice">
                                <option [ngValue]="null">Select existing device</option>
                                <option [ngValue]="filteredDevice" *ngFor="let filteredDevice of filteredDevices">
                                    {{ filteredDevice.name }}
                                </option>
                            </select>
                            <div class="invalid-feedback"
                                *ngIf="addDeviceForm.invalid && (controls.filteredDevice.touched || controls.filteredDevice.dirty)"
                                data-cy-validation="filteredDevice">
                                <div *ngIf="controls.filteredDevice.hasError('required')">Existing Device is required</div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-4">
                        <div class="form-group col-12">
                            <button type="submit" class="btn btn-primary btn-block" data-cy-button="confirm">
                                Confirm
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>